export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-26.1b434550.jpg";